// Minimal type wrapper around the Telegram WebApp global.
// Spec: https://core.telegram.org/bots/webapps

export interface TgUser {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: { user?: TgUser; auth_date?: number; query_id?: string };
  ready(): void;
  expand(): void;
  close(): void;
  colorScheme: "light" | "dark";
  themeParams: Record<string, string>;
  MainButton: {
    text: string;
    setText(t: string): void;
    show(): void;
    hide(): void;
    onClick(cb: () => void): void;
    offClick(cb: () => void): void;
  };
  BackButton: {
    show(): void;
    hide(): void;
    onClick(cb: () => void): void;
    offClick(cb: () => void): void;
  };
  HapticFeedback: {
    impactOccurred(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void;
    notificationOccurred(type: "error" | "success" | "warning"): void;
    selectionChanged?(): void;
  };
  showAlert(message: string): void;
  showConfirm(message: string, cb: (ok: boolean) => void): void;
  openLink?(url: string, options?: { try_instant_view?: boolean }): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function tg(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function initData(): string {
  // In dev (browser, not Telegram) — empty string; backend will 401 then.
  return tg()?.initData ?? "";
}

export function tgUser(): TgUser | null {
  return tg()?.initDataUnsafe?.user ?? null;
}
